<div class="me-auto pc-mob-drp">
  <ul class="list-unstyled">

    <!-- Mobile menu toggle -->
    <li class="pc-h-item header-mobile-collapse">
      <a
        href="javascript:"
        class="pc-head-link head-link-secondary ms-0 mobile-menu"
        (click)="navCollapsedMob()"
      >
        <i class="ti ti-menu-2"></i>
      </a>
    </li>

  </ul>
</div>